import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import AOS from "aos";
import "aos/dist/aos.css";
import i18n from "./i18n";
import store from "./state/store";

import BootstrapVueNext from "bootstrap-vue-next";
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import { vMaska } from "maska";
import Select2 from "vue3-select2-component";

import VueFeather from "vue-feather";
import vue3GoogleLogin from "vue3-google-login";
import PrimeVue from "primevue/config";

import "@/assets/scss/config/material/app.scss";
import "@/assets/scss/mermaid.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "primevue/resources/themes/aura-light-green/theme.css";
import "primevue/resources/primevue.min.css";

window.addEventListener('error', (event) => {
  if (event.message && 
      (event.message.includes('Loading chunk') || 
       event.message.includes('ChunkLoadError'))) {
    console.warn('Chunk loading failed, reloading page...');
    window.location.reload();
  }
});

// Handler untuk unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.name === 'ChunkLoadError') {
    console.warn('Chunk loading failed, reloading page...');
    event.preventDefault();
    window.location.reload();
  }
});


// FakeBackend authentication
// import { configureFakeBackend } from './helpers/fake-backend';
// configureFakeBackend();

// Firebase authentication
// import { initFirebaseBackend } from './authUtils';

// const firebaseConfig = {
//     apiKey: process.env.VUE_APP_APIKEY,
//     authDomain: process.env.VUE_APP_AUTHDOMAIN,
//     databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
//     projectId: process.env.VUE_APP_PROJECTId,
//     storageBucket: process.env.VUE_APP_STORAGEBUCKET,
//     messagingSenderId: process.env.VUE_APP_MEASUREMENTID
// };

// initFirebaseBackend(firebaseConfig);

AOS.init({
  easing: "ease-out-back",
  duration: 1000,
});

createApp(App)
  .use(store)
  .use(router)
  .use(VueApexCharts)
  .use(BootstrapVueNext)
  .component("vue-select2", Select2)
  .component(VueFeather.type, VueFeather)
  .directive("maska", vMaska)
  .use(i18n)
  .use(vClickOutside)
  .use(vue3GoogleLogin, {
    clientId:
      "98557907696-nsv2l2nq7crnbbslhh486bengfjvn8as.apps.googleusercontent.com",
  })
  .use(PrimeVue, { ripple: true })
  .mount("#app");
